export default __webpack_public_path__ + "static/media/corgi.9af2ae05.png";